import { SCREENWIDTH_CHANGE } from '../mutation-types';

const state = {

    screenWidth: 'pc',
    isMobile: false

};

type TScreenWidthState = typeof state;

const mutations = {

    [ SCREENWIDTH_CHANGE ]( state: TScreenWidthState, width: string ): void {

        state.screenWidth = width;
        state.isMobile = width === 'mobile';

    }

};
const getters = {

    screenWidth: ( state: TScreenWidthState ): string => state.screenWidth,
    isMobile: ( state: TScreenWidthState ): boolean => state.isMobile

};

export default {

    state,
    mutations,
    getters

};
